(function () {
  'use strict';

  function query(root, selector) {
    return root.querySelector(selector);
  }

  function queryAll(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function numericRange(start, end, step) {
    var values = [];
    var count = Math.round((end - start) / step);
    for (var index = 0; index <= count; index += 1) {
      var number = Math.round((start + (index * step)) * 100) / 100;
      values.push({ value: number.toFixed(2), label: (number > 0 ? '+' : '') + number.toFixed(2) });
    }
    return values;
  }

  function contactPowers(profile) {
    var values = [];
    if (profile.plain) values.push({ value: '0.00', label: '0.00 (Plain)' });
    if (profile.positive) {
      var positive = profile.positive;
      while (positive >= 0.5) {
        values.push({ value: positive.toFixed(2), label: '+' + positive.toFixed(2) });
        positive -= positive > 6 ? 0.5 : 0.25;
      }
    }
    var power = profile.start || -0.5;
    var fineTo = profile.fineTo || -5;
    while (power >= -profile.negative) {
      values.push({ value: power.toFixed(2), label: power.toFixed(2) });
      power -= power > fineTo ? 0.25 : 0.5;
      power = Math.round(power * 100) / 100;
    }
    return values;
  }

  var CONTACT_PROFILES = {
    'acuvue-2': { negative: 6 },
    'acuvue-oasys': { negative: 6 },
    'acuvue-moist-1-day': { negative: 10 },
    'freshlook': { negative: 8, plain: true, fineTo: -6 },
    'focus-dailies': { negative: 10, fineTo: -6 },
    'polyvue': { negative: 10, positive: 6, fineTo: -6 },
    'o2-optix': { negative: 10, plain: true, fineTo: -6 },
    'acuity': { negative: 10, fineTo: -6 },
    'avaira-vitality': { negative: 12, positive: 8, fineTo: -6 },
    'bausch-lomb-soflens-59': { negative: 9, fineTo: -6 },
    'bausch-lomb-soflens-daily-disposable': { negative: 9, fineTo: -6 },
    'bausch-lomb-ultra': { negative: 12, start: -0.25, fineTo: -6 },
    'biomedics-1-day-extra': { negative: 8, fineTo: -6 },
    'biomedics-55': { negative: 10, positive: 6, fineTo: -6 },
    'forever': { negative: 16, fineTo: -6 },
    'bella-clear-vision': { negative: 8, fineTo: -6 },
    'freshlook-one-day': { negative: 6, plain: true, fineTo: -6 },
    'solotica-hidrocor': { negative: 4, plain: true, fineTo: -6 },
    'solotica-soflex-natural': { negative: 4, plain: true, fineTo: -6 },
    'adore': { negative: 15, plain: true, fineTo: -6 },
    'eyesoft-divine': { negative: 10, plain: true, fineTo: -6 },
    'eyesoft-prime': { negative: 10, plain: true, fineTo: -6 },
    'eyesoft-transparent': { negative: 10, plain: true, fineTo: -6 },
    'fashion-look': { negative: 10, plain: true, fineTo: -6 },
    'bella-diamond-aseel-collection': { negative: 8, plain: true, fineTo: -6 },
    'bella-diamond-collection': { negative: 8, plain: true, fineTo: -6 },
    'bella-elite-collection': { negative: 8, plain: true, fineTo: -6 },
    'bella-glow-collection': { negative: 8, plain: true, fineTo: -6 },
    'bella-natural-collection': { negative: 8, plain: true, fineTo: -6 },
    'complex-iv': { negative: 10 },
    'ultima': { negative: 10, plain: true, fineTo: -6 },
    'bausch-lomb-soflens': { negative: 6, plain: true, fineTo: -6 },
    'bella-1-day-collection': { negative: 6, plain: true, fineTo: -4 },
    'biomedics-toric': { negative: 8, plain: true, fineTo: -6 },
    'comfort-color-toric': { negative: 8, plain: true, fineTo: -6 },
    'eyesoft-color-toric': { negative: 8, plain: true, fineTo: -6 },
    'flexcon': { negative: 20, positive: 20, fineTo: -6 },
    'freshkon-fusion': { negative: 10, plain: true, fineTo: -6 },
    'freshkon-mosaic': { negative: 8, plain: true, fineTo: -6 },
    'hydro': { negative: 10, plain: true, fineTo: -6 },
    'target': { negative: 20 },
    'unique': { negative: 20, positive: 10, fineTo: -6 },
    'visicon': { negative: 10, fineTo: -6 },
    'neo-cosmo-color-contact-lens': { negative: 20, plain: true, fineTo: -6 },
    'neo-vision-eyepia-55uv': { negative: 20, plain: true, fineTo: -6 },
    'focus-color-contact-lens': { negative: 10, plain: true, fineTo: -6 },
    'comfort-basic-series': { negative: 10, plain: true, fineTo: -6 },
    'comfort-bio-luc-series': { negative: 10, plain: true, fineTo: -6 },
    'comfort-hidrocor-series': { negative: 10, plain: true, fineTo: -6 },
    'comfort-jewel-series': { negative: 10, plain: true, fineTo: -6 },
    'comfort-pretty-7-day-series': { negative: 10, plain: true, fineTo: -6 },
    'comfort-rainbow-series': { negative: 10, plain: true, fineTo: -6 },
    'comfort-three-tone-series': { negative: 10, plain: true, fineTo: -6 },
    'optiano-ex': { negative: 10, plain: true, fineTo: -6 },
    'optiano-uv-55-extended-wear': { negative: 10, plain: true, fineTo: -6 },
    'eyesoft-1-day-color': { negative: 6, plain: true, fineTo: -6 },
    'optiano': { negative: 6, plain: true, fineTo: -6 },
    'eyesoft-transparent-toric': { negative: 10, plain: true },
    'gloria-transparent-toric': { negative: 10, plain: true },
    'ina-series-color-contact': { negative: 8, plain: true, fineTo: -6 },
    'naturel-color-contacts': { negative: 8, plain: true, fineTo: -6 }
  };

  var GLASS_SPHERE = numericRange(-16, 12, 0.25);
  var SUN_SPHERE = numericRange(-0.25, -25, -0.25);
  var CYLINDER = numericRange(-0.25, -6, -0.25);

  var DATA = {
    eyeglasses: {
      usage: [
        { value: 'far_vision', label: 'Far Vision', desc: 'Distance vision', lensTypes: ['clear', 'bluelight', 'transitions'] },
        { value: 'near_vision', label: 'Near Vision', desc: 'Reading and close work', lensTypes: ['clear', 'bluelight'] },
        { value: 'bifocal', label: 'Bifocal', desc: 'Distance and reading zones', lensTypes: ['clear'], showPd: true },
        { value: 'non_prescription', label: 'Non-Prescription', desc: 'Lenses without vision correction', lensTypes: ['clear', 'bluelight', 'transitions'], noPrescription: true },
        { value: 'progressive', label: 'Progressive', desc: 'Seamless distance, intermediate and near vision', lensTypes: ['clear'], showPd: true, showPdSplit: true, showComments: true }
      ],
      lensTypes: {
        clear: { label: 'Clear' },
        bluelight: { label: 'Blue Light Filtering' },
        transitions: { label: 'Transitions' }
      },
      packages: {
        far_vision: {
          clear: [
            { value: 'fv_clear_1', label: 'Simple Hard Coat Lens', price: 600 },
            { value: 'fv_clear_2', label: 'Multicoat UV Lens UV400', price: 1200 },
            { value: 'fv_clear_3', label: 'Premium Anti Glare · Super Hydrophobic · UV400', price: 2200 },
            { value: 'fv_clear_4', label: 'Premium Anti Glare · High Index above -6.00', price: 4500 }
          ],
          bluelight: [
            { value: 'fv_blue_1', label: 'Basic Blue Light Lens', price: 800 },
            { value: 'fv_blue_2', label: 'Medium Anti Glare · UV420 · Hydrophobic', price: 1500 },
            { value: 'fv_blue_3', label: 'Premium Anti Glare · UV420 · Hydrophobic', price: 2200 },
            { value: 'fv_blue_4', label: 'Ultra-Thin Anti Glare · UV420 · Hydrophobic', price: 4200 }
          ],
          transitions: [
            { value: 'fv_transition_1', label: 'Basic Transition Lens', price: 1100 },
            { value: 'fv_transition_2', label: 'Medium Transition Lens', price: 1800 },
            { value: 'fv_transition_3', label: 'Premium Transition Lens', price: 3000 }
          ]
        },
        near_vision: {
          clear: [
            { value: 'nv_clear_1', label: 'Simple Hard Coat Lens', price: 600 },
            { value: 'nv_clear_2', label: 'Premium Anti Glare · Super Hydrophobic · UV400', price: 2200 }
          ],
          bluelight: [
            { value: 'nv_blue_1', label: 'Basic Blue Light Lens', price: 800 },
            { value: 'nv_blue_2', label: 'Medium Anti Glare · UV420 · Hydrophobic', price: 1500 },
            { value: 'nv_blue_3', label: 'Premium Anti Glare · UV420 · Hydrophobic', price: 2200 },
            { value: 'nv_blue_4', label: 'Ultra-Thin Anti Glare · UV420 · Hydrophobic', price: 4200 }
          ]
        },
        bifocal: {
          clear: [
            { value: 'bf_clear_1', label: 'Simple Hard Coat Lens', price: 1600 },
            { value: 'bf_clear_2', label: 'Premium Anti Glare · Super Hydrophobic · UV400', price: 4500 }
          ]
        },
        non_prescription: {
          clear: [
            { value: 'np_clear_1', label: 'Simple Hard Coat Lens', price: 600 },
            { value: 'np_clear_2', label: 'Multicoat UV Lens UV400', price: 1200 },
            { value: 'np_clear_3', label: 'Premium Anti Glare · Super Hydrophobic · UV400', price: 2200 }
          ],
          bluelight: [
            { value: 'np_blue_1', label: 'Basic Blue Light Lens', price: 800 },
            { value: 'np_blue_2', label: 'Medium Anti Glare · UV420 · Hydrophobic', price: 1500 },
            { value: 'np_blue_3', label: 'Premium Anti Glare · UV420 · Hydrophobic', price: 2200 }
          ],
          transitions: [
            { value: 'np_transition_1', label: 'Basic Transition Lens', price: 1100 },
            { value: 'np_transition_2', label: 'Medium Transition Lens', price: 1800 },
            { value: 'np_transition_3', label: 'Premium Transition Lens', price: 3000 }
          ]
        },
        progressive: {
          clear: [
            { value: 'pg_clear_1', label: 'Medium Hard Coat Lens', price: 2000 },
            { value: 'pg_clear_2', label: 'Premium Anti Glare · Super Hydrophobic · UV400', price: 9000 }
          ]
        }
      },
      tints: [
        { value: 'grey', label: 'Grey Outdoors, Clear Indoors' },
        { value: 'brown', label: 'Brown Outdoors, Clear Indoors' }
      ]
    },
    sunglasses: {
      packages: [
        { value: 'normal', label: 'Normal Lens', price: 2000 },
        { value: 'high_index', label: 'High Index Lens', price: 2500 }
      ]
    }
  };

  function LensConfigurator(root) {
    this.root = root;
    this.category = root.getAttribute('data-lc-category');
    this.currency = root.getAttribute('data-lc-currency') || 'Rs';
    this.productHandle = root.getAttribute('data-lc-product-handle') || '';
    this.productTitle = root.getAttribute('data-lc-product-title') || '';
    this.formId = root.getAttribute('data-lc-form-id') || '';
    this.icons = {
      far_vision: root.getAttribute('data-lc-icon-far-vision'),
      near_vision: root.getAttribute('data-lc-icon-near-vision'),
      bifocal: root.getAttribute('data-lc-icon-bifocal'),
      progressive: root.getAttribute('data-lc-icon-progressive'),
      non_prescription: root.getAttribute('data-lc-icon-frame'),
      frame: root.getAttribute('data-lc-icon-frame'),
      clear: root.getAttribute('data-lc-icon-clear'),
      normal: root.getAttribute('data-lc-icon-clear'),
      bluelight: root.getAttribute('data-lc-icon-blue-light'),
      transitions: root.getAttribute('data-lc-icon-transition'),
      high_index: root.getAttribute('data-lc-icon-high-index')
    };
    this.art = {
      clear: root.getAttribute('data-lc-art-clear'),
      bluelight: root.getAttribute('data-lc-art-blue-light'),
      transitions: root.getAttribute('data-lc-art-transition'),
      bifocal: root.getAttribute('data-lc-art-bifocal'),
      progressive: root.getAttribute('data-lc-art-progressive')
    };
    this.form = root.closest('form') || document.getElementById(this.formId);
    this.copy = this.readCopy();
    this.addOnVariants = this.readAddOnVariants();
    this.submitting = false;
    this.state = { withPower: null, configured: false, method: 'manual', requiresPrescription: true, values: {}, addlPrice: 0 };
    this.init();
  }

  LensConfigurator.prototype.readCopy = function () {
    var script = query(this.root, '[data-lc-copy]');
    if (!script) return {};
    try { return JSON.parse(script.textContent); } catch (error) { return {}; }
  };

  LensConfigurator.prototype.readAddOnVariants = function () {
    var script = query(this.root, '[data-lc-addon-variants]');
    if (!script) return {};
    try { return JSON.parse(script.textContent); } catch (error) { return {}; }
  };

  LensConfigurator.prototype.init = function () {
    this.bindLauncher();
    this.bindDialog();
    this.bindMethods();
    this.bindFile();
    this.bindInputs();
    this.bindForm();
    if (this.category === 'eyeglasses') this.initEyeglasses();
    if (this.category === 'sunglasses') this.initSunglasses();
    if (this.category === 'contacts') this.initContacts();
    this.updateMethod();
    this.updatePrice();
  };

  LensConfigurator.prototype.bindLauncher = function () {
    var self = this;
    var open = query(this.root, '[data-lc-open]');
    var frame = query(this.root, '[data-lc-frame-only]');
    var change = query(this.root, '[data-lc-change]');
    if (open) open.addEventListener('click', function () {
      self.state.withPower = true;
      self.setChoice('lenses');
      self.clearLauncherError();
      self.openDialog();
    });
    if (frame) frame.addEventListener('click', function () {
      self.state.withPower = false;
      self.state.configured = true;
      self.state.addlPrice = 0;
      self.setChoice('frame');
      self.clearLauncherError();
      self.updateSelection();
      self.writeProperties();
    });
    if (change) change.addEventListener('click', function () {
      self.state.configured = false;
      query(self.root, '[data-lc-selection]').hidden = true;
      queryAll(self.root, '.lc-choice').forEach(function (button) {
        button.classList.remove('is-selected');
        button.setAttribute('aria-checked', 'false');
      });
    });
  };

  LensConfigurator.prototype.setChoice = function (choice) {
    queryAll(this.root, '.lc-choice').forEach(function (button) {
      var selected = choice === 'lenses' ? button.hasAttribute('data-lc-open') : button.hasAttribute('data-lc-frame-only');
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
  };

  LensConfigurator.prototype.bindDialog = function () {
    var self = this;
    var dialog = query(this.root, '[data-lc-dialog]');
    queryAll(this.root, '[data-lc-close]').forEach(function (button) {
      button.addEventListener('click', function () { if (dialog && dialog.open) dialog.close(); });
    });
    var save = query(this.root, '[data-lc-save]');
    if (save) save.addEventListener('click', function () {
      if (!self.validate()) return;
      self.state.withPower = true;
      self.state.configured = true;
      self.setChoice('lenses');
      self.writeProperties();
      self.updateSelection();
      if (dialog && dialog.open) dialog.close();
    });
    if (dialog) dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  };

  LensConfigurator.prototype.openDialog = function () {
    var dialog = query(this.root, '[data-lc-dialog]');
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var body = query(this.root, '.lc-dialog__body');
    if (body) body.scrollTop = 0;
  };

  LensConfigurator.prototype.bindMethods = function () {
    var self = this;
    queryAll(this.root, '[data-lc-method]').forEach(function (button) {
      button.addEventListener('click', function () {
        queryAll(self.root, '[data-lc-method]').forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-checked', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-checked', 'true');
        self.state.method = button.getAttribute('data-lc-method');
        self.clearError();
        self.updateMethod();
        self.updateProgress();
      });
    });
  };

  LensConfigurator.prototype.updateMethod = function () {
    var method = query(this.root, '[data-lc-rx-method]');
    var manual = query(this.root, '[data-lc-manual-panel]');
    var upload = query(this.root, '[data-lc-upload-panel]');
    var ready = this.category !== 'eyeglasses' || Boolean(this.state.values.usage);
    if (method) method.hidden = !ready || !this.state.requiresPrescription;
    if (manual) manual.hidden = !ready || !this.state.requiresPrescription || this.state.method !== 'manual';
    if (upload) upload.hidden = !ready || !this.state.requiresPrescription || this.state.method !== 'upload';
  };

  LensConfigurator.prototype.bindInputs = function () {
    var self = this;
    queryAll(this.root, '[data-lc-input]').forEach(function (input) {
      input.addEventListener('input', function () { self.clearError(); self.updateProgress(); });
    });
  };

  LensConfigurator.prototype.resetSelect = function (name, placeholder) {
    var select = query(this.root, '[data-lc-select="' + name + '"]');
    if (!select) return;
    select.innerHTML = '';
    var option = document.createElement('option');
    option.value = '';
    option.textContent = placeholder || this.copy.selectPower || 'Please select';
    option.disabled = true;
    option.selected = true;
    select.appendChild(option);
  };

  LensConfigurator.prototype.renderOptions = function (name, options, onPick, placeholder) {
    var self = this;
    var select = query(this.root, '[data-lc-select="' + name + '"]');
    if (!select) return;
    this.resetSelect(name, placeholder);
    options.forEach(function (item) {
      var option = document.createElement('option');
      option.value = item.value;
      option.textContent = item.label + (typeof item.price === 'number' ? '  ·  +' + self.formatPrice(item.price) : '');
      select.appendChild(option);
    });
    select.onchange = function () {
      var selected = options.filter(function (item) { return item.value === select.value; })[0];
      self.clearError();
      if (selected) onPick(selected);
    };
  };

  LensConfigurator.prototype.initEyeglasses = function () {
    var self = this;
    this.renderOptions('usage', DATA.eyeglasses.usage, function (option) {
      self.state.values = { usage: option.value, usageLabel: option.label };
      self.state.addlPrice = 0;
      self.state.requiresPrescription = !option.noPrescription;
      self.onEyeglassesUsage(option);
    }, this.copy.selectUsage);
  };

  LensConfigurator.prototype.onEyeglassesUsage = function (usage) {
    var self = this;
    var lensStep = query(this.root, '[data-lc-step="lenstype"]');
    var tintStep = query(this.root, '[data-lc-step="tint"]');
    var packageStep = query(this.root, '[data-lc-step="package"]');
    if (lensStep) lensStep.hidden = false;
    if (tintStep) tintStep.hidden = true;
    if (packageStep) packageStep.hidden = true;
    this.renderOptions('lenstype', usage.lensTypes.map(function (key) {
      return { value: key, label: DATA.eyeglasses.lensTypes[key].label };
    }), function (option) { self.onLensType(usage, option); }, this.copy.selectLensType);
    this.renderPrescription(GLASS_SPHERE, CYLINDER);
    this.togglePd(usage);
    this.updateMethod();
    this.updatePrice();
    this.updateProgress();
  };

  LensConfigurator.prototype.onLensType = function (usage, lensType) {
    var self = this;
    var tintStep = query(this.root, '[data-lc-step="tint"]');
    var packageStep = query(this.root, '[data-lc-step="package"]');
    this.state.values.lenstype = lensType.value;
    this.state.values.lenstypeLabel = lensType.label;
    delete this.state.values.tint;
    delete this.state.values.tintLabel;
    delete this.state.values.pkg;
    delete this.state.values.pkgLabel;
    this.state.addlPrice = 0;
    if (tintStep) tintStep.hidden = lensType.value !== 'transitions';
    if (lensType.value === 'transitions') {
      this.renderOptions('tint', DATA.eyeglasses.tints, function (option) {
        self.state.values.tint = option.value;
        self.state.values.tintLabel = option.label;
        self.updateProgress();
      }, this.copy.selectTint);
    }
    var packages = ((DATA.eyeglasses.packages[usage.value] || {})[lensType.value] || []);
    if (packageStep) packageStep.hidden = packages.length === 0;
    this.renderOptions('package', packages, function (option) {
      self.state.values.pkg = option.value;
      self.state.values.pkgLabel = option.label;
      self.state.values.pkgPrice = option.price;
      self.state.addlPrice = option.price;
      self.updatePrice();
      self.updateProgress();
    }, this.copy.selectPackage);
    this.updatePrice();
    this.updateProgress();
  };

  LensConfigurator.prototype.renderPrescription = function (spheres, cylinders) {
    var self = this;
    ['sph_r', 'sph_l'].forEach(function (key) {
      self.renderOptions(key, spheres, function (option) { self.state.values[key] = option.value; self.updateProgress(); }, self.copy.selectPower);
    });
    ['cyl_r', 'cyl_l'].forEach(function (key) {
      self.renderOptions(key, cylinders, function (option) { self.state.values[key] = option.value; self.updateProgress(); }, self.copy.selectPower);
    });
  };

  LensConfigurator.prototype.togglePd = function (usage) {
    var pdField = query(this.root, '[data-lc-pd-field]');
    var checkbox = query(this.root, '[data-lc-input="pd_split"]');
    var single = query(this.root, '[data-lc-pd-single]');
    var double = query(this.root, '[data-lc-pd-double]');
    var comments = query(this.root, '[data-lc-comments-field]');
    if (pdField) pdField.hidden = !usage.showPd;
    if (comments) comments.hidden = !usage.showComments;
    if (!checkbox) return;
    checkbox.parentElement.hidden = !usage.showPdSplit;
    checkbox.checked = false;
    if (single) single.hidden = false;
    if (double) double.hidden = true;
    checkbox.onchange = function () {
      if (single) single.hidden = checkbox.checked;
      if (double) double.hidden = !checkbox.checked;
    };
  };

  LensConfigurator.prototype.initSunglasses = function () {
    var self = this;
    this.state.values.usage = 'far_vision';
    this.state.values.usageLabel = 'Far Vision';
    this.renderOptions('package', DATA.sunglasses.packages, function (option) {
      self.state.values.pkg = option.value;
      self.state.values.pkgLabel = option.label;
      self.state.values.pkgPrice = option.price;
      self.state.addlPrice = option.price;
      self.updatePrice();
      self.updateProgress();
    }, this.copy.selectPackage);
    this.renderPrescription(SUN_SPHERE, CYLINDER);
  };

  LensConfigurator.prototype.initContacts = function () {
    var self = this;
    var profile = CONTACT_PROFILES[this.productHandle] || { negative: 6 };
    var powers = contactPowers(profile);
    ['os_power', 'od_power'].forEach(function (key) {
      self.renderOptions(key, powers, function (option) { self.state.values[key] = option.value; self.updateProgress(); }, self.copy.selectPower);
    });
  };

  LensConfigurator.prototype.bindFile = function () {
    var self = this;
    var input = query(this.root, '[data-lc-file-input]');
    var filename = query(this.root, '[data-lc-upload-filename]');
    if (!input) return;
    if (this.formId) input.setAttribute('form', this.formId);
    input.addEventListener('change', function () {
      self.clearError();
      if (!input.files || !input.files[0]) {
        filename.hidden = true;
        filename.textContent = '';
        return;
      }
      if (input.files[0].size > 10485760) {
        self.showError(self.copy.fileTooLarge || 'Please choose a file smaller than 10MB.');
        input.value = '';
        filename.hidden = true;
        return;
      }
      filename.hidden = false;
      filename.textContent = (self.copy.selectedFile || 'Selected:') + ' ' + input.files[0].name;
      self.updateProgress();
    });
  };

  LensConfigurator.prototype.bindForm = function () {
    var self = this;
    if (!this.form) return;
    this.form.addEventListener('submit', function (event) {
      if (!self.state.configured) {
        event.preventDefault();
        event.stopImmediatePropagation();
        self.showLauncherError(self.copy.selectRequired || 'Please select lenses or frame only.');
        return;
      }
      if (self.state.withPower && !self.validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        self.openDialog();
        return;
      }
      self.writeProperties();
      if (self.state.withPower && self.state.addlPrice > 0) {
        var addOnVariantId = self.addOnVariants[String(self.state.addlPrice)];
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!addOnVariantId) {
          self.showLauncherError('This lens price is temporarily unavailable. Please contact us for help.');
          return;
        }
        self.submitConfiguredOrder(addOnVariantId, event.submitter);
      }
    }, true);
  };

  LensConfigurator.prototype.submitConfiguredOrder = function (addOnVariantId, submitter) {
    var self = this;
    if (this.submitting) return;
    this.submitting = true;
    var configurationId = 'LC-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase();
    this.addProperty('_Lens Configuration ID', configurationId);
    var formData = new FormData(this.form);
    var quantity = Number(formData.get('quantity') || 1);
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var mainLineKey = '';
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }

    fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'Unable to add the frame.');
        mainLineKey = payload.key || '';
        return fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [{
              id: Number(addOnVariantId),
              quantity: quantity,
              properties: {
                '_Lens Configuration ID': configurationId,
                'For': self.productTitle,
                'Lens Package': self.state.values.pkgLabel || 'Prescription lens upgrade'
              }
            }]
          })
        });
      });
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'Unable to add the lens package.');
        window.location.assign(rootPath + 'cart');
      });
    }).catch(function (error) {
      var cleanup = mainLineKey ? fetch(rootPath + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: mainLineKey, quantity: 0 })
      }) : Promise.resolve();
      cleanup.finally(function () {
        self.submitting = false;
        if (submitter) {
          submitter.disabled = false;
          submitter.removeAttribute('aria-busy');
        }
        self.showLauncherError(error.message || 'Unable to add your configured lenses. Please try again.');
      });
    });
  };

  LensConfigurator.prototype.validate = function () {
    this.clearError();
    var values = this.state.values;
    var missing = [];
    if (this.category === 'eyeglasses') {
      if (!values.usage) missing.push('usage');
      if (values.usage && !values.lenstype) missing.push('lens type');
      if (values.lenstype === 'transitions' && !values.tint) missing.push('tint colour');
      if (values.lenstype && !values.pkg) missing.push('lens package');
    }
    if (this.category === 'sunglasses' && !values.pkg) missing.push('lens package');
    if (this.state.requiresPrescription && this.state.method === 'upload') {
      var file = query(this.root, '[data-lc-file-input]');
      if (!file || !file.files || !file.files[0]) {
        this.showError(this.copy.uploadRequired || 'Please choose your prescription file.');
        return false;
      }
    } else if (this.state.requiresPrescription && this.category === 'contacts') {
      if (!values.os_power) missing.push('left-eye power');
      if (!values.od_power) missing.push('right-eye power');
    } else if (this.state.requiresPrescription && (this.category === 'eyeglasses' || this.category === 'sunglasses')) {
      ['sph_r', 'cyl_r', 'sph_l', 'cyl_l'].forEach(function (key) { if (!values[key]) missing.push(key); });
      ['axis_r', 'axis_l'].forEach(function (key) {
        var field = query(this.root, '[data-lc-input="' + key + '"]');
        if (!field || field.value === '') missing.push(key);
      }, this);
      if (this.category === 'eyeglasses' && (values.usage === 'bifocal' || values.usage === 'progressive')) {
        var split = query(this.root, '[data-lc-input="pd_split"]');
        if (split && split.checked) {
          if (!query(this.root, '[data-lc-input="pd_right"]').value) missing.push('right PD');
          if (!query(this.root, '[data-lc-input="pd_left"]').value) missing.push('left PD');
        } else if (!query(this.root, '[data-lc-input="pd"]').value) missing.push('PD');
      }
    }
    if (missing.length) {
      this.showError((this.copy.required || 'Please complete the required lens details.') + ' (' + missing.length + ')');
      return false;
    }
    return true;
  };

  LensConfigurator.prototype.showError = function (message) {
    var error = query(this.root, '[data-lc-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    error.focus({ preventScroll: true });
  };

  LensConfigurator.prototype.clearError = function () {
    var error = query(this.root, '[data-lc-error]');
    if (error) error.hidden = true;
  };

  LensConfigurator.prototype.showLauncherError = function (message) {
    var error = query(this.root, '[data-lc-launcher-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    this.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  LensConfigurator.prototype.clearLauncherError = function () {
    var error = query(this.root, '[data-lc-launcher-error]');
    if (error) error.hidden = true;
  };

  LensConfigurator.prototype.clearProperties = function () {
    if (!this.form) return;
    queryAll(this.form, '[data-lc-injected]').forEach(function (input) { input.remove(); });
  };

  LensConfigurator.prototype.addProperty = function (name, value) {
    if (!this.form || value === undefined || value === null || value === '') return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + name + ']';
    input.value = value;
    input.setAttribute('data-lc-injected', 'true');
    this.form.appendChild(input);
  };

  LensConfigurator.prototype.writeProperties = function () {
    this.clearProperties();
    if (!this.state.withPower) {
      this.addProperty('Lens Selection', this.category === 'contacts' ? 'Plano / no power' : 'Frame Only');
      return;
    }
    var values = this.state.values;
    this.addProperty('Lens Selection', this.category === 'sunglasses' ? 'Prescription Sunglasses' : this.category === 'contacts' ? 'Contact Lens Power' : 'Prescription Lenses');
    this.addProperty('Usage', values.usageLabel);
    this.addProperty('Lens Type', values.lenstypeLabel);
    this.addProperty('Tint Colour', values.tintLabel);
    this.addProperty('Lens Package', values.pkgLabel);
    if (values.pkgPrice) this.addProperty('Lens Price', this.formatPrice(values.pkgPrice));
    if (!this.state.requiresPrescription) {
      this.addProperty('Prescription', 'No prescription');
      return;
    }
    this.addProperty('Prescription Method', this.state.method === 'upload' ? 'Uploaded prescription' : 'Entered manually');
    if (this.category === 'contacts') {
      this.addProperty('O.S Power (Left)', values.os_power);
      this.addProperty('O.D Power (Right)', values.od_power);
      return;
    }
    if (this.state.method === 'manual') {
      this.addProperty('Sphere (Right)', values.sph_r);
      this.addProperty('Cylinder (Right)', values.cyl_r);
      this.addProperty('Axis (Right)', query(this.root, '[data-lc-input="axis_r"]').value);
      this.addProperty('Sphere (Left)', values.sph_l);
      this.addProperty('Cylinder (Left)', values.cyl_l);
      this.addProperty('Axis (Left)', query(this.root, '[data-lc-input="axis_l"]').value);
      if (this.category === 'eyeglasses') {
        var split = query(this.root, '[data-lc-input="pd_split"]');
        if (split && split.checked) {
          this.addProperty('PD (Right)', query(this.root, '[data-lc-input="pd_right"]').value);
          this.addProperty('PD (Left)', query(this.root, '[data-lc-input="pd_left"]').value);
        } else {
          var pd = query(this.root, '[data-lc-input="pd"]');
          if (pd) this.addProperty('PD', pd.value);
        }
        var comments = query(this.root, '[data-lc-input="comments"]');
        if (comments) this.addProperty('Additional Comments', comments.value);
      }
    }
  };

  LensConfigurator.prototype.updateSelection = function () {
    var box = query(this.root, '[data-lc-selection]');
    var text = query(this.root, '[data-lc-selection-text]');
    if (!box || !text) return;
    var summary;
    if (!this.state.withPower) summary = this.category === 'contacts' ? this.copy.planoSummary : this.copy.frameSummary;
    else if (this.category === 'contacts') summary = (this.copy.powerSummary || 'Power selected') + ': O.S ' + this.state.values.os_power + ' · O.D ' + this.state.values.od_power;
    else summary = (this.copy.lensSummary || 'Lenses selected') + (this.state.values.pkgLabel ? ' · ' + this.state.values.pkgLabel : '');
    text.textContent = summary;
    box.hidden = false;
  };

  LensConfigurator.prototype.formatPrice = function (number) {
    return this.currency + ' ' + Number(number).toLocaleString('en-PK');
  };

  LensConfigurator.prototype.updatePrice = function () {
    var banner = query(this.root, '[data-lc-price-banner]');
    var total = query(this.root, '[data-lc-price-total]');
    if (!banner || !total) return;
    banner.hidden = this.state.addlPrice <= 0;
    total.textContent = this.formatPrice(this.state.addlPrice);
  };

  LensConfigurator.prototype.updateProgress = function () {
    var active = 'options';
    if (this.category === 'contacts') active = this.state.values.os_power || this.state.values.od_power || this.state.method === 'upload' ? 'prescription' : 'options';
    else if (this.state.values.pkg) active = 'prescription';
    var complete = this.state.method === 'upload' ? Boolean(query(this.root, '[data-lc-file-input]').files[0]) : Boolean(this.state.values.sph_r || this.state.values.os_power) || !this.state.requiresPrescription;
    if (complete) active = 'review';
    queryAll(this.root, '[data-lc-progress]').forEach(function (item) {
      var step = item.getAttribute('data-lc-progress');
      item.classList.toggle('is-active', step === active);
      item.classList.toggle('is-complete', (step === 'options' && active !== 'options') || (step === 'prescription' && active === 'review'));
    });
  };

  LensConfigurator.prototype.init = function () {
    this.state.screen = 'power';
    this.state.hasCylinder = false;
    this.bindLauncher();
    this.bindDialog();
    this.bindFile();
    this.bindInputs();
    this.bindForm();
    this.bindPowerHelpers();
    if (this.category === 'eyeglasses') {
      this.renderPrescription(GLASS_SPHERE, CYLINDER);
      this.renderPowerCards();
    }
    if (this.category === 'sunglasses') {
      this.state.values.usage = 'far_vision';
      this.state.values.usageLabel = 'Far Vision';
      this.renderPrescription(SUN_SPHERE, CYLINDER);
      this.renderSunglassCards();
    }
    if (this.category === 'contacts') this.initContacts();
    this.showScreen(this.category === 'eyeglasses' ? 'power' : this.category === 'sunglasses' ? 'lenses' : 'manual');
  };

  LensConfigurator.prototype.bindLauncher = function () {
    var self = this;
    var open = query(this.root, '[data-lc-open]');
    var frame = query(this.root, '[data-lc-frame-only]');
    var change = query(this.root, '[data-lc-change]');
    if (open) open.addEventListener('click', function () {
      self.state.withPower = true;
      self.state.configured = false;
      self.setChoice('lenses');
      self.clearLauncherError();
      self.showScreen(self.category === 'eyeglasses' ? 'power' : self.category === 'sunglasses' ? 'lenses' : 'manual');
      self.openDialog();
    });
    if (frame) frame.addEventListener('click', function () { self.completeFrameOnly(); });
    if (change) change.addEventListener('click', function () {
      self.state.configured = false;
      query(self.root, '[data-lc-selection]').hidden = true;
      queryAll(self.root, '.lc-choice').forEach(function (button) {
        button.classList.remove('is-selected');
        button.setAttribute('aria-checked', 'false');
      });
    });
  };

  LensConfigurator.prototype.completeFrameOnly = function () {
    this.state.withPower = false;
    this.state.configured = true;
    this.state.addlPrice = 0;
    this.setChoice('frame');
    this.clearLauncherError();
    this.writeProperties();
    this.updateSelection();
    var dialog = query(this.root, '[data-lc-dialog]');
    if (dialog && dialog.open) dialog.close();
  };

  LensConfigurator.prototype.bindDialog = function () {
    var self = this;
    var dialog = query(this.root, '[data-lc-dialog]');
    var back = query(this.root, '[data-lc-back]');
    var save = query(this.root, '[data-lc-save]');
    if (back) back.addEventListener('click', function () { self.goBack(); });
    queryAll(this.root, '[data-lc-method]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.state.method = button.getAttribute('data-lc-method');
        self.showScreen(self.state.method === 'upload' ? 'upload' : 'manual');
      });
    });
    if (save) save.addEventListener('click', function () { self.saveSelection(); });
    if (dialog) dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  };

  LensConfigurator.prototype.openDialog = function () {
    var dialog = query(this.root, '[data-lc-dialog]');
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var body = query(this.root, '.lc-dialog__body');
    if (body) body.scrollTop = 0;
  };

  LensConfigurator.prototype.goBack = function () {
    var dialog = query(this.root, '[data-lc-dialog]');
    if (this.state.screen === 'manual' || this.state.screen === 'upload') {
      if (this.category === 'contacts') {
        if (dialog && dialog.open) dialog.close();
      } else this.showScreen('method');
      return;
    }
    if (this.state.screen === 'method') {
      this.showScreen('lenses');
      return;
    }
    if (this.state.screen === 'lenses' && this.category === 'eyeglasses') {
      this.showScreen('power');
      return;
    }
    if (dialog && dialog.open) dialog.close();
  };

  LensConfigurator.prototype.showScreen = function (screen) {
    this.state.screen = screen;
    queryAll(this.root, '[data-lc-screen]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-lc-screen') !== screen;
    });
    var footer = query(this.root, '[data-lc-footer]');
    if (footer) footer.hidden = screen !== 'manual' && screen !== 'upload';
    var title = query(this.root, '[data-lc-header-title]');
    if (title) title.textContent = screen === 'manual' || screen === 'upload' ? 'Submit Eye Power' : 'Add Lens Details';
    var body = query(this.root, '.lc-dialog__body');
    if (body) body.scrollTop = 0;
    this.clearError();
    this.updateProgress();
  };

  LensConfigurator.prototype.cardIcon = function (kind) {
    var artKey = kind.indexOf('art_') === 0 ? kind.replace('art_', '') : '';
    var source = artKey ? this.art[artKey] : (this.icons[kind] || this.icons.clear);
    if (!source) return '';
    return '<img src="' + source + '" alt="" width="' + (artKey ? '180' : '64') + '" height="' + (artKey ? '180' : '64') + '">';
  };

  LensConfigurator.prototype.makeCard = function (option, icon, badge) {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'lc-nav-card';
    var features = (option.desc || '').split(' · ').filter(Boolean).slice(0, 3);
    var detail = features.length ? '<ul>' + features.map(function (item) { return '<li>' + item + '</li>'; }).join('') + '</ul>' : '<small>' + (option.desc || '') + '</small>';
    card.innerHTML = '<span class="lc-card-visual lc-card-visual--' + icon + '">' + this.cardIcon(icon) + '</span>' +
      '<span class="lc-card-copy">' + (badge ? '<em>' + badge + '</em>' : '') + '<strong>' + option.label + '</strong>' + detail +
      (typeof option.price === 'number' ? '<span class="lc-card-price"><small>Frame + lens</small><b>+' + this.formatPrice(option.price) + '</b></span>' : '') + '</span>' +
      '<span class="lc-card-arrow" aria-hidden="true">›</span>';
    return card;
  };

  LensConfigurator.prototype.renderPowerCards = function () {
    var self = this;
    var container = query(this.root, '[data-lc-power-cards]');
    if (!container) return;
    container.innerHTML = '';
    DATA.eyeglasses.usage.forEach(function (usage) {
      var card = self.makeCard(usage, usage.value, usage.value === 'far_vision' ? 'Most common' : '');
      card.addEventListener('click', function () {
        self.state.values = { usage: usage.value, usageLabel: usage.label };
        self.state.requiresPrescription = !usage.noPrescription;
        self.state.addlPrice = 0;
        self.togglePd(usage);
        self.renderEyeglassCards(usage);
        self.showScreen('lenses');
      });
      container.appendChild(card);
    });
    var frame = this.makeCard({ label: 'Frame Only', desc: 'Continue without prescription lenses' }, 'frame', '');
    frame.addEventListener('click', function () { self.completeFrameOnly(); });
    container.appendChild(frame);
  };

  LensConfigurator.prototype.renderEyeglassCards = function (usage) {
    var self = this;
    var container = query(this.root, '[data-lc-lens-cards]');
    var tint = query(this.root, '[data-lc-tint-picker]');
    if (!container) return;
    container.innerHTML = '';
    if (tint) tint.hidden = true;
    usage.lensTypes.forEach(function (lensKey) {
      var lens = DATA.eyeglasses.lensTypes[lensKey];
      var packages = ((DATA.eyeglasses.packages[usage.value] || {})[lensKey] || []);
      packages.forEach(function (pkg) {
        var parts = pkg.label.split(' · ');
        var option = { label: parts.shift(), desc: parts.join(' · '), price: pkg.price };
        var artKey = usage.value === 'bifocal' || usage.value === 'progressive' ? usage.value : lensKey;
        var card = self.makeCard(option, 'art_' + artKey, lens.label);
        card.addEventListener('click', function () { self.pickPackage(usage, lensKey, pkg); });
        container.appendChild(card);
      });
    });
  };

  LensConfigurator.prototype.renderSunglassCards = function () {
    var self = this;
    var container = query(this.root, '[data-lc-lens-cards]');
    if (!container) return;
    container.innerHTML = '';
    DATA.sunglasses.packages.forEach(function (pkg) {
      var desc = pkg.value === 'high_index' ? 'Thinner profile · Lightweight finish · High-power friendly' : 'Clear prescription sun lens · Everyday optical finish';
      var artKey = pkg.value === 'high_index' ? 'transitions' : 'clear';
      var card = self.makeCard({ label: pkg.label, desc: desc, price: pkg.price }, 'art_' + artKey, pkg.value === 'normal' ? 'Most common' : '');
      card.addEventListener('click', function () {
        self.state.values.pkg = pkg.value;
        self.state.values.pkgLabel = pkg.label;
        self.state.values.pkgPrice = pkg.price;
        self.state.addlPrice = pkg.price;
        self.state.requiresPrescription = true;
        self.showScreen('method');
      });
      container.appendChild(card);
    });
  };

  LensConfigurator.prototype.pickPackage = function (usage, lensKey, pkg) {
    this.state.values.lenstype = lensKey;
    this.state.values.lenstypeLabel = DATA.eyeglasses.lensTypes[lensKey].label;
    this.state.values.pkg = pkg.value;
    this.state.values.pkgLabel = pkg.label;
    this.state.values.pkgPrice = pkg.price;
    this.state.addlPrice = pkg.price;
    if (lensKey === 'transitions') {
      this.renderTintOptions(usage);
      return;
    }
    delete this.state.values.tint;
    delete this.state.values.tintLabel;
    if (usage.noPrescription) this.saveSelection();
    else this.showScreen('method');
  };

  LensConfigurator.prototype.renderTintOptions = function (usage) {
    var self = this;
    var picker = query(this.root, '[data-lc-tint-picker]');
    var container = query(this.root, '[data-lc-tint-options]');
    if (!picker || !container) return;
    picker.hidden = false;
    container.innerHTML = '';
    DATA.eyeglasses.tints.forEach(function (tint) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'lc-tint';
      button.innerHTML = '<span class="lc-tint__swatch lc-tint__swatch--' + tint.value + '"></span><span><strong>' + tint.label.split(',')[0] + '</strong><small>' + (tint.label.split(',')[1] || 'Clear indoors') + '</small></span>';
      button.addEventListener('click', function () {
        self.state.values.tint = tint.value;
        self.state.values.tintLabel = tint.label;
        if (usage.noPrescription) self.saveSelection();
        else self.showScreen('method');
      });
      container.appendChild(button);
    });
    picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  LensConfigurator.prototype.initContacts = function () {
    var self = this;
    var powers = contactPowers(CONTACT_PROFILES[this.productHandle] || { negative: 6 });
    ['os_power', 'od_power'].forEach(function (key) {
      self.renderOptions(key, powers, function (option) {
        self.state.values[key] = option.value;
        self.syncSamePower(key, option.value);
      }, self.copy.selectPower);
    });
  };

  LensConfigurator.prototype.renderPrescription = function (spheres, cylinders) {
    var self = this;
    ['sph_r', 'sph_l'].forEach(function (key) {
      self.renderOptions(key, spheres, function (option) {
        self.state.values[key] = option.value;
        self.syncSamePower(key, option.value);
      }, self.copy.selectPower);
    });
    ['cyl_r', 'cyl_l'].forEach(function (key) {
      self.renderOptions(key, cylinders, function (option) {
        self.state.values[key] = option.value;
        self.syncSamePower(key, option.value);
      }, self.copy.selectPower);
    });
  };

  LensConfigurator.prototype.bindPowerHelpers = function () {
    var self = this;
    var same = query(this.root, '[data-lc-same-power]');
    var cylinder = query(this.root, '[data-lc-cylinder-toggle]');
    if (same) same.addEventListener('change', function () {
      var manual = same.closest('[data-lc-manual-panel]');
      var heading = query(self.root, '[data-lc-right-heading]');
      var note = query(self.root, '[data-lc-same-power-note]');
      if (manual) manual.classList.toggle('is-same-power', same.checked);
      if (heading) heading.textContent = same.checked ? heading.getAttribute('data-both-label') : heading.getAttribute('data-right-label');
      if (note) note.hidden = !same.checked;
      if (!same.checked) return;
      var pairs = self.category === 'contacts' ? [['od_power', 'os_power']] : [['sph_r', 'sph_l'], ['cyl_r', 'cyl_l'], ['axis_r', 'axis_l']];
      pairs.forEach(function (pair) {
        var source = query(self.root, '[data-lc-select="' + pair[0] + '"], [data-lc-input="' + pair[0] + '"]');
        var target = query(self.root, '[data-lc-select="' + pair[1] + '"], [data-lc-input="' + pair[1] + '"]');
        if (source && target && source.value) {
          target.value = source.value;
          self.state.values[pair[1]] = source.value;
        }
      });
    });
    if (cylinder) cylinder.addEventListener('change', function () {
      self.state.hasCylinder = cylinder.checked;
      queryAll(self.root, '[data-lc-cylinder-fields]').forEach(function (row) { row.hidden = !cylinder.checked; });
    });
  };

  LensConfigurator.prototype.syncSamePower = function (key, value) {
    var same = query(this.root, '[data-lc-same-power]');
    if (!same || !same.checked) return;
    var pair = { sph_r: 'sph_l', cyl_r: 'cyl_l', od_power: 'os_power' }[key];
    if (!pair) return;
    var target = query(this.root, '[data-lc-select="' + pair + '"]');
    if (target) target.value = value;
    this.state.values[pair] = value;
  };

  LensConfigurator.prototype.bindInputs = function () {
    var self = this;
    queryAll(this.root, '[data-lc-input]').forEach(function (input) {
      input.addEventListener('input', function () {
        self.clearError();
        if (query(self.root, '[data-lc-same-power]') && query(self.root, '[data-lc-same-power]').checked) {
          if (input.getAttribute('data-lc-input') === 'axis_r') query(self.root, '[data-lc-input="axis_l"]').value = input.value;
        }
      });
    });
  };

  LensConfigurator.prototype.saveSelection = function () {
    if (!this.validate()) return;
    this.state.withPower = true;
    this.state.configured = true;
    this.setChoice('lenses');
    this.writeProperties();
    this.updateSelection();
    var dialog = query(this.root, '[data-lc-dialog]');
    if (dialog && dialog.open) dialog.close();
  };

  LensConfigurator.prototype.validate = function () {
    this.clearError();
    var values = this.state.values;
    var missing = [];
    if (this.category === 'eyeglasses') {
      if (!values.usage) missing.push('power type');
      if (!values.pkg) missing.push('lens package');
      if (values.lenstype === 'transitions' && !values.tint) missing.push('tint colour');
    }
    if (this.category === 'sunglasses' && !values.pkg) missing.push('lens package');
    if (this.state.requiresPrescription && this.state.method === 'upload') {
      var file = query(this.root, '[data-lc-file-input]');
      if (!file || !file.files || !file.files[0]) missing.push('prescription file');
    } else if (this.state.requiresPrescription && this.category === 'contacts') {
      if (!values.od_power) missing.push('right-eye power');
      if (!values.os_power) missing.push('left-eye power');
    } else if (this.state.requiresPrescription) {
      if (!values.sph_r) missing.push('right sphere');
      if (!values.sph_l) missing.push('left sphere');
      if (this.state.hasCylinder) {
        if (!values.cyl_r) missing.push('right cylinder');
        if (!values.cyl_l) missing.push('left cylinder');
        if (!query(this.root, '[data-lc-input="axis_r"]').value) missing.push('right axis');
        if (!query(this.root, '[data-lc-input="axis_l"]').value) missing.push('left axis');
      }
      if (this.category === 'eyeglasses' && (values.usage === 'bifocal' || values.usage === 'progressive')) {
        var split = query(this.root, '[data-lc-input="pd_split"]');
        if (split && split.checked) {
          if (!query(this.root, '[data-lc-input="pd_right"]').value) missing.push('right PD');
          if (!query(this.root, '[data-lc-input="pd_left"]').value) missing.push('left PD');
        } else if (!query(this.root, '[data-lc-input="pd"]').value) missing.push('PD');
      }
    }
    if (missing.length) {
      this.showError((this.copy.required || 'Please complete the required lens details.') + ' (' + missing.length + ')');
      return false;
    }
    return true;
  };

  LensConfigurator.prototype.writeProperties = function () {
    this.clearProperties();
    if (!this.state.withPower) {
      this.addProperty('Lens Selection', this.category === 'contacts' ? 'Plano / no power' : 'Frame Only');
      return;
    }
    var values = this.state.values;
    this.addProperty('Lens Selection', this.category === 'sunglasses' ? 'Prescription Sunglasses' : this.category === 'contacts' ? 'Contact Lens Power' : 'Prescription Lenses');
    this.addProperty('Usage', values.usageLabel);
    this.addProperty('Lens Type', values.lenstypeLabel);
    this.addProperty('Tint Colour', values.tintLabel);
    this.addProperty('Lens Package', values.pkgLabel);
    if (values.pkgPrice) this.addProperty('Lens Price', this.formatPrice(values.pkgPrice));
    if (!this.state.requiresPrescription) {
      this.addProperty('Prescription', 'No prescription');
      return;
    }
    this.addProperty('Prescription Method', this.state.method === 'upload' ? 'Uploaded prescription' : 'Entered manually');
    var samePower = query(this.root, '[data-lc-same-power]');
    samePower = Boolean(samePower && samePower.checked);
    if (this.category === 'contacts') {
      if (samePower) {
        this.addProperty('Power (Both Eyes)', values.od_power);
        this.addProperty('Same Power for Both Eyes', 'Yes');
      } else {
        this.addProperty('O.D Power (Right)', values.od_power);
        this.addProperty('O.S Power (Left)', values.os_power);
      }
      return;
    }
    if (this.state.method === 'manual') {
      if (samePower) {
        this.addProperty('Sphere (Both Eyes)', values.sph_r);
        this.addProperty('Same Power for Both Eyes', 'Yes');
      } else {
        this.addProperty('Sphere (Right)', values.sph_r);
        this.addProperty('Sphere (Left)', values.sph_l);
      }
      if (this.state.hasCylinder && samePower) {
        this.addProperty('Cylinder (Both Eyes)', values.cyl_r);
        this.addProperty('Axis (Both Eyes)', query(this.root, '[data-lc-input="axis_r"]').value);
      } else if (this.state.hasCylinder) {
        this.addProperty('Cylinder (Right)', values.cyl_r);
        this.addProperty('Axis (Right)', query(this.root, '[data-lc-input="axis_r"]').value);
        this.addProperty('Cylinder (Left)', values.cyl_l);
        this.addProperty('Axis (Left)', query(this.root, '[data-lc-input="axis_l"]').value);
      } else this.addProperty('Cylindrical Power', 'None');
      if (this.category === 'eyeglasses') {
        var split = query(this.root, '[data-lc-input="pd_split"]');
        if (split && split.checked) {
          this.addProperty('PD (Right)', query(this.root, '[data-lc-input="pd_right"]').value);
          this.addProperty('PD (Left)', query(this.root, '[data-lc-input="pd_left"]').value);
        } else {
          var pd = query(this.root, '[data-lc-input="pd"]');
          if (pd) this.addProperty('PD', pd.value);
        }
        var comments = query(this.root, '[data-lc-input="comments"]');
        if (comments) this.addProperty('Additional Comments', comments.value);
      }
    }
  };

  LensConfigurator.prototype.updateProgress = function () {
    var screen = this.state.screen;
    var active = screen === 'power' ? 'power' : screen === 'lenses' ? 'lenses' : 'prescription';
    var order = { power: 0, lenses: 1, prescription: 2 };
    queryAll(this.root, '[data-lc-progress]').forEach(function (item) {
      var step = item.getAttribute('data-lc-progress');
      item.classList.toggle('is-active', step === active);
      item.classList.toggle('is-complete', order[step] < order[active]);
    });
  };

  function initialize(scope) {
    queryAll(scope || document, '.lc:not([data-lc-ready])').forEach(function (root) {
      root.setAttribute('data-lc-ready', 'true');
      new LensConfigurator(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());
